export default "__VITE_ASSET__U0hJ1KYi__"